
































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';

@Component
export default class HelpContentView extends Vue {
  public items: Common.HelpContent[] = new Array(0);
  public params: Common.HelpContentQuery = new Common.HelpContentQuery();
  public exportQuery = new Common.ExportQuery('ヘルプ記事', this.params);
  public importQuery = new Common.ImportQuery('ヘルプ記事', 'HelpContent');  
  public sortOptions: any = [{ value: 'collection_order', text: 'コレクション' },{ value: 'prioritized', text: '表示区分' },{ value: 'score', text: '表示スコア' },{ value: 'id', text: '記事ID' }];
  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }  
}
